/* eslint-disable */
import axios from 'axios'
// import { Message } from 'element-ui'
import toast from './toast/toast'
import router from '../router'
import {root} from '../utils/chHostconfig.js'


function isMobile() {
  let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile!= null
}
console.log('当前设备是什么',isMobile());
let ismobile=isMobile();

const baseUrl = root
axios.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json'
  let token = localStorage.getItem('token') || ''
  if (token && !config.url.includes('songshuai')) {
    config.headers['yx-token'] = token
  }
  return config
}, error => {
  return Promise.reject(error)
})

axios.interceptors.response.use(response => {
  return response
}, error => {
  console.log(error)
  return Promise.resolve(error)
})

function checkStatus (response) {
  // console.log(response)
  // 登录失效
  if (response.data.code === 1001) {
    // Message({
    //   message: '登录失效，请重新登录',
    //   type: 'error',
    //   duration: 2 * 1000
    // })
    if (ismobile) {
      setTimeout(function () {
        console.log('当前设备是mobile');
        router.push('/dl-mobile/login')
      }, 1000)
      return $toast('登录失效，请重新登录')
    }else{
      setTimeout(function () {
        console.log('当前设备是pc');
        router.push('/dl-web/login')
      }, 1000)
      return toast('登录失效，请重新登录')
    }
  } else {
    return response.data
  }
}

export default {
  post (res) {
    return axios({
      method: 'post',
      baseURL: baseUrl,
      url: res.url,
      data: JSON.stringify(res.data),
      timeout: 10000
      // headers: head
    }).then(
      (response) => {
        // console.log(response)
        return checkStatus(response)
      }
    ).catch(error => {
      console.log(error)
    })
  },
  get (url, params) {
    return axios({
      method: 'get',
      baseURL: baseUrl,
      url,
      params, // get 请求时带的参数
      timeout: 10000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(
      (response) => {
        return checkStatus(response)
      }
    ).catch(
      (rej) => {
        return rej
      }
    )
  }
  // setToken: function (token) {
  //   head['yx-token'] = token
  // }
}
